import React, { useState, useEffect, useRef, useCallback } from "react";
import { MessageList } from "react-chat-elements";
import { Crud_Catalogos } from "../../herramientas/Crud_Catalogos";
import * as conf from "../../config/config";
import "react-chat-elements/dist/main.css";

// Chat de servicio entre el monitorista (SkyOneFront) y el operador (app
// SkyTruck). Usa el token de sesión de SkyOne directamente contra la API de
// SkyTruck (Crud_Catalogos ya adjunta sessionStorage["tok"] como Bearer en
// cada request vía axios.defaults.headers.common, ver Auth/Auth.js).
const POLL_MS = 4000;

const mapMensaje = (m) => ({
  position: m.remitenteTipo === "OPERADOR" ? "left" : "right",
  type: "text",
  title: m.remitenteTipo === "OPERADOR" ? "Operador" : "Tú",
  text: m.contenido,
  date: m.createdAt ? new Date(m.createdAt) : undefined,
});

const ServicioChatSkyTruck = ({ movimiento }) => {
  const servicioId = movimiento && movimiento.idMovimiento;
  const [mensajes, setMensajes] = useState([]);
  const [texto, setTexto] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [error, setError] = useState("");
  const contenedorRef = useRef(null);

  const cargarMensajes = useCallback(() => {
    if (!servicioId) return;
    Crud_Catalogos(
      "mensajes/servicio/" + servicioId,
      "",
      "get",
      "",
      [],
      "",
      "chat",
      "",
      [],
      "",
      conf.skytruck_api
    )
      .then((data) => {
        if (Array.isArray(data)) {
          const ordenado = [...data].sort(
            (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
          );
          setMensajes(ordenado.map(mapMensaje));
          setError("");
        }
      })
      .catch(() => setError("No se pudo cargar la conversación de SkyTruck"));
  }, [servicioId]);

  useEffect(() => {
    cargarMensajes();
    const t = setInterval(cargarMensajes, POLL_MS);
    return () => clearInterval(t);
  }, [cargarMensajes]);

  useEffect(() => {
    if (contenedorRef.current) {
      contenedorRef.current.scrollTop = contenedorRef.current.scrollHeight;
    }
  }, [mensajes]);

  const enviar = () => {
    const contenido = texto.trim();
    if (!contenido || !servicioId || enviando) return;
    setEnviando(true);
    Crud_Catalogos(
      "mensajes",
      "mensajes",
      "post",
      "",
      { servicioId, tipo: "TEXTO", contenido },
      "",
      "chat",
      "",
      [],
      "",
      conf.skytruck_api
    )
      .then((res) => {
        if (res) {
          setTexto("");
          cargarMensajes();
        } else {
          setError("No se pudo enviar el mensaje");
        }
      })
      .finally(() => setEnviando(false));
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      enviar();
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", height: 500 }}>
      <div
        ref={contenedorRef}
        style={{ flex: 1, overflowY: "auto", padding: "10px 5px" }}
      >
        <MessageList
          className="message-list"
          lockable={true}
          toBottomHeight={"100%"}
          dataSource={mensajes}
        />
      </div>
      {error && (
        <div style={{ color: "#c0392b", padding: "0 10px", fontSize: 13 }}>
          {error}
        </div>
      )}
      <div
        style={{
          display: "flex",
          borderTop: "1px solid #e0e0e0",
          padding: 10,
        }}
      >
        <input
          type="text"
          value={texto}
          onChange={(e) => setTexto(e.target.value)}
          onKeyDown={onKeyDown}
          placeholder="Escribe un mensaje..."
          style={{
            flex: 1,
            borderRadius: 20,
            border: "1px solid #ccc",
            padding: "8px 15px",
            outline: "none",
          }}
        />
        <button
          onClick={enviar}
          disabled={enviando || !texto.trim()}
          style={{
            marginLeft: 10,
            borderRadius: "50%",
            width: 40,
            height: 40,
            border: "none",
            background: "#25d366",
            color: "#fff",
            cursor: enviando ? "default" : "pointer",
          }}
        >
          <i className="fa fa-paper-plane" />
        </button>
      </div>
    </div>
  );
};

export default ServicioChatSkyTruck;
